export default __webpack_public_path__ + "static/media/Resume.487365d7.pdf";